@if (passwordControl) {
  <div
    class="content app-btn-small_font-size text-shadow"
    [class.g-flex]="inLine"
    [class.g-flex--justify-center]="inLine"
    [class.g-flex--wrap]="inLine"
    [class.column-gap-10]="inLine">
    <div>{{ 'password.at-least' | translate }}</div>

    <div
      [class.color-red-fire]="passwordControl && passwordControl.value && !passwordControl.value.match('^(?=.*[A-Z])')"
      [class.text-shadow-negative]="
        passwordControl && passwordControl.value && !passwordControl.value.match('^(?=.*[A-Z])')
      ">
      <span>{{ 'password.upper-case' | translate }}</span>
      @if (inLine) {
        <span>,</span>
      }
    </div>

    <div
      [class.color-red-fire]="passwordControl && passwordControl.value && !passwordControl.value.match('(?=.*[a-z])')"
      [class.text-shadow-negative]="
        passwordControl && passwordControl.value && !passwordControl.value.match('(?=.*[a-z])')
      ">
      <span>{{ 'password.lower-case' | translate }}</span>
      @if (inLine) {
        <span>,</span>
      }
    </div>

    <div
      [class.color-red-fire]="passwordControl && passwordControl.value && !passwordControl.value.match('(.*[0-9].*)')"
      [class.text-shadow-negative]="
        passwordControl && passwordControl.value && !passwordControl.value.match('(.*[0-9].*)')
      ">
      <span>{{ 'password.digit' | translate }}</span>
      @if (inLine) {
        <span>,</span>
      }
    </div>

    <div
      [class.color-red-fire]="
        passwordControl && passwordControl.value && !passwordControl.value.match('(?=.*[!@#$%^&*])')
      "
      [class.text-shadow-negative]="
        passwordControl && passwordControl.value && !passwordControl.value.match('(?=.*[!@#$%^&*])')
      ">
      <span>{{ 'password.special' | translate }}</span>
      @if (inLine) {
        <span>,</span>
      }
    </div>

    <div
      [class.color-red-fire]="passwordControl && passwordControl.value && !passwordControl.value.match('.{8,}')"
      [class.text-shadow-negative]="passwordControl && passwordControl.value && !passwordControl.value.match('.{8,}')">
      <span>{{ 'password.length' | translate }}</span>
      @if (inLine && !!newPasswordControl) {
        <span>,</span>
      }
    </div>

    @if (!!newPasswordControl) {
      <div
        [class.color-red-fire]="passwordControl.value !== newPasswordControl.value"
        [class.text-shadow-negative]="passwordControl.value !== newPasswordControl.value">
        <span>{{ 'password.match' | translate }}</span>
      </div>
    }
  </div>
}
